import { Education, Tool } from './types';
import { ABOUT_ASSETS, CAROUSEL_ASSETS } from './assets';

export const NAV_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Projects', path: '/projects' },
  { label: 'Certifications', path: '/certifications' },
];

// Ensures links start with http/https to prevent javascript: malicious scripts
export const safeUrl = (url: string | null | undefined): string => {
  if (!url) return '#';
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol) ? url : '#';
  } catch {
    return '#'; // Invalid URL format
  }
};

export const TRUSTED_BRANDS = [
  { 
    name: 'GitHub', 
    url: CAROUSEL_ASSETS.githublogo, 
  },
  { 
    name: 'Microsoft', 
    url: CAROUSEL_ASSETS.microsoftlogo, 
  },
  { 
    name: 'Dicoding', 
    url: CAROUSEL_ASSETS.dicodingheaderlogo, 
  },
  { 
    name: 'IBM', 
    url: CAROUSEL_ASSETS.ibmlogo, 
  },
  { 
    name: 'Coursera', 
    url: CAROUSEL_ASSETS.courseralogo, 
  },
  { 
    name: 'HackerRank', 
    url: CAROUSEL_ASSETS.hackerranklogo, 
  },
  { 
    name: 'edX', 
    url: CAROUSEL_ASSETS.edxlogo, 
  },
  { 
    name: 'JetBrains Academy', 
    url: CAROUSEL_ASSETS.jetbrainsacademylogo, 
  },
  { 
    name: 'Google Cloud', 
    url: CAROUSEL_ASSETS.googlecloudlogo, 
  },
  { 
    name: 'Nvidia', 
    url: CAROUSEL_ASSETS.nvidialogo, 
  },
  { 
    name: 'Kaggle', 
    url: CAROUSEL_ASSETS.kagglelogo, 
  },
  { 
    name: 'AWS', 
    url: CAROUSEL_ASSETS.awslogo, 
  },
  { 
    name: 'Cisco', 
    url: CAROUSEL_ASSETS.ciscologo, 
  },
  { 
    name: 'SoloLearn', 
    url: CAROUSEL_ASSETS.sololearnlogo, 
  },
  { 
    name: 'Mimo', 
    url: CAROUSEL_ASSETS.mimologo, 
  },
  {
    name: 'HP Life',
    url: CAROUSEL_ASSETS.hplifelogo,
  },
];


export const EDUCATION: Education[] = [
  {
    id: '1',
    school: 'Universitas Negeri Semarang (UNNES)',
    degree: 'Bachelor of Information Systems',
    logo: ABOUT_ASSETS.unneslogo,
    period: '2025 — Present',
    description: 'Currently pursuing a Bachelor\'s degree in Information Systems, focusing on software development, data analysis, and information management.',
    color: 'border-primary'
  },
  {
    id: '2',
    school: 'SMAN 9 Semarang',
    degree: 'High School',
    logo: ABOUT_ASSETS.sman9logo,
    period: '2022 — 2025',
    description: 'Completed high school education with a focus on informatics and mathematics, laying the foundation for a career in technology and software development.',
    color: 'border-border-dark'
  },
];

export const ALL_TOOLS: Tool[] = [
  // Language
  { name: 'JavaScript', category: 'Language', url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript', logo: 'https://cdn.simpleicons.org/javascript', color: 'hover:bg-[#F7DF1E]/10 dark:hover:bg-[#F7DF1E]/10 hover:border-[#F7DF1E] dark:hover:border-[#F7DF1E] group-hover:text-[#F7DF1E] dark:group-hover:text-[#F7DF1E]' },
  { name: 'TypeScript', category: 'Language', url: 'https://www.typescriptlang.org/', logo: 'https://cdn.simpleicons.org/typescript', color: 'hover:bg-[#3178C6]/10 dark:hover:bg-[#3178C6]/10 hover:border-[#3178C6] dark:hover:border-[#3178C6] group-hover:text-[#3178C6] dark:group-hover:text-[#3178C6]' },
  { name: 'Python', category: 'Language', url: 'https://www.python.org/', logo: 'https://cdn.simpleicons.org/python', color: 'hover:bg-[#3776AB]/10 dark:hover:bg-[#3776AB]/10 hover:border-[#3776AB] dark:hover:border-[#3776AB] group-hover:text-[#3776AB] dark:group-hover:text-[#3776AB]' },
  { name: 'C++', category: 'Language', url: 'https://isocpp.org/', logo: 'https://cdn.simpleicons.org/cplusplus', color: 'hover:bg-[#00599C]/10 dark:hover:bg-[#00599C]/10 hover:border-[#00599C] dark:hover:border-[#00599C] group-hover:text-[#00599C] dark:group-hover:text-[#00599C]' },
  { name: 'Kotlin', category: 'Language', url: 'https://kotlinlang.org/', logo: 'https://cdn.simpleicons.org/kotlin', color: 'hover:bg-[#7F52FF]/10 dark:hover:bg-[#7F52FF]/10 hover:border-[#7F52FF] dark:hover:border-[#7F52FF] group-hover:text-[#7F52FF] dark:group-hover:text-[#7F52FF]' },
  { name: 'Rust', category: 'Language', url: 'https://www.rust-lang.org/', logo: 'https://cdn.simpleicons.org/rust', color: 'hover:bg-[#000000]/10 dark:hover:bg-[#000000]/10 hover:border-[#000000] dark:hover:border-[#000000] group-hover:text-[#000000] dark:group-hover:text-[#000000]' },
  { name: 'Lua', category: 'Language', url: 'https://www.lua.org/', logo: 'https://cdn.simpleicons.org/lua', color: 'hover:bg-[#2C2D72]/10 dark:hover:bg-[#2C2D72]/10 hover:border-[#2C2D72] dark:hover:border-[#2C2D72] group-hover:text-[#2C2D72] dark:group-hover:text-[#2C2D72]' },
  
  // Frontend
  { name: 'React', category: 'Frontend', url: 'https://react.dev/', logo: 'https://cdn.simpleicons.org/react', color: 'hover:bg-[#61DAFB]/10 dark:hover:bg-[#61DAFB]/10 hover:border-[#61DAFB] dark:hover:border-[#61DAFB] group-hover:text-[#61DAFB] dark:group-hover:text-[#61DAFB]' },
  { name: 'Vite', category: 'Frontend', url: 'https://vitejs.dev/', logo: 'https://cdn.simpleicons.org/vite', color: 'hover:bg-[#646CFF]/10 dark:hover:bg-[#646CFF]/10 hover:border-[#646CFF] dark:hover:border-[#646CFF] group-hover:text-[#646CFF] dark:group-hover:text-[#646CFF]' },
  { name: 'Tailwind', category: 'Frontend', url: 'https://tailwindcss.com/', logo: 'https://cdn.simpleicons.org/tailwindcss', color: 'hover:bg-[#06B6D4]/10 dark:hover:bg-[#06B6D4]/10 hover:border-[#06B6D4] dark:hover:border-[#06B6D4] group-hover:text-[#06B6D4] dark:group-hover:text-[#06B6D4]' },
  
  // Backend & DB
  { name: 'Node.js', category: 'Backend & DB', url: 'https://nodejs.org/', logo: 'https://cdn.simpleicons.org/nodedotjs', color: 'hover:bg-[#339933]/10 dark:hover:bg-[#339933]/10 hover:border-[#339933] dark:hover:border-[#339933] group-hover:text-[#339933] dark:group-hover:text-[#339933]' },
  { name: 'PostgreSQL', category: 'Backend & DB', url: 'https://www.postgresql.org/', logo: 'https://cdn.simpleicons.org/postgresql', color: 'hover:bg-[#4169E1]/10 dark:hover:bg-[#4169E1]/10 hover:border-[#4169E1] dark:hover:border-[#4169E1] group-hover:text-[#4169E1] dark:group-hover:text-[#4169E1]' },
  { name: 'MySQL', category: 'Backend & DB', url: 'https://www.mysql.com/', logo: 'https://cdn.simpleicons.org/mysql', color: 'hover:bg-[#4479A1]/10 dark:hover:bg-[#4479A1]/10 hover:border-[#4479A1] dark:hover:border-[#4479A1] group-hover:text-[#4479A1] dark:group-hover:text-[#4479A1]' },
  { name: 'Supabase', category: 'Backend & DB', url: 'https://supabase.com/', logo: 'https://cdn.simpleicons.org/supabase', color: 'hover:bg-[#3ECF8E]/10 dark:hover:bg-[#3ECF8E]/10 hover:border-[#3ECF8E] dark:hover:border-[#3ECF8E] group-hover:text-[#3ECF8E] dark:group-hover:text-[#3ECF8E]' },

  // Data & Auto
  { name: 'Pandas', category: 'Data & Auto', url: 'https://pandas.pydata.org/', logo: 'https://cdn.simpleicons.org/pandas', color: 'hover:bg-[#150458]/10 dark:hover:bg-[#150458]/10 hover:border-[#150458] dark:hover:border-[#150458] group-hover:text-[#150458] dark:group-hover:text-[#150458]' },
  { name: 'Power BI', category: 'Data & Auto', url: 'https://powerbi.microsoft.com/', logo: 'https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg', color: 'hover:bg-[#F2C811]/10 dark:hover:bg-[#F2C811]/10 hover:border-[#F2C811] dark:hover:border-[#F2C811] group-hover:text-[#F2C811] dark:group-hover:text-[#F2C811]' },
  { name: 'n8n', category: 'Data & Auto', url: 'https://n8n.io/', logo: 'https://cdn.simpleicons.org/n8n', color: 'hover:bg-[#FF6584]/10 dark:hover:bg-[#FF6584]/10 hover:border-[#FF6584] dark:hover:border-[#FF6584] group-hover:text-[#FF6584] dark:group-hover:text-[#FF6584]' },
  { name: 'Microsoft Fabric', category: 'Data & Auto', url: 'https://www.microsoft.com/en-us/microsoft-fabric', logo: ABOUT_ASSETS.microsoftfabriclogo, color: 'hover:bg-[#6264A7]/10 dark:hover:bg-[#6264A7]/10 hover:border-[#6264A7] dark:hover:border-[#6264A7] group-hover:text-[#6264A7] dark:group-hover:text-[#6264A7]' },
  
  // Cloud & DevOps
  { name: 'Azure', category: 'Cloud & DevOps', url: 'https://azure.microsoft.com/', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/azure/azure-original.svg', color: 'hover:bg-[#0089D6]/10 dark:hover:bg-[#0089D6]/10 hover:border-[#0089D6] dark:hover:border-[#0089D6] group-hover:text-[#0089D6] dark:group-hover:text-[#0089D6]' },
  { name: 'Docker', category: 'Cloud & DevOps', url: 'https://www.docker.com/', logo: 'https://cdn.simpleicons.org/docker', color: 'hover:bg-[#2496ED]/10 dark:hover:bg-[#2496ED]/10 hover:border-[#2496ED] dark:hover:border-[#2496ED] group-hover:text-[#2496ED] dark:group-hover:text-[#2496ED]' },
  { name: 'Netlify', category: 'Cloud & DevOps', url: 'https://www.netlify.com/', logo: 'https://cdn.simpleicons.org/netlify', color: 'hover:bg-[#00C7B7]/10 dark:hover:bg-[#00C7B7]/10 hover:border-[#00C7B7] dark:hover:border-[#00C7B7] group-hover:text-[#00C7B7] dark:group-hover:text-[#00C7B7]' },

  // Design
  { name: 'Figma', category: 'Design', url: 'https://www.figma.com/', logo: 'https://cdn.simpleicons.org/figma', color: 'hover:bg-[#F24E1E]/10 dark:hover:bg-[#F24E1E]/10 hover:border-[#F24E1E] dark:hover:border-[#F24E1E] group-hover:text-[#F24E1E] dark:group-hover:text-[#F24E1E]' },
  { name: 'Canva', category: 'Design', url: 'https://www.canva.com/', logo: 'https://upload.wikimedia.org/wikipedia/en/b/bb/Canva_Logo.svg', color: 'hover:bg-[#00C4CC]/10 dark:hover:bg-[#00C4CC]/10 hover:border-[#00C4CC] dark:hover:border-[#00C4CC] group-hover:text-[#00C4CC] dark:group-hover:text-[#00C4CC]' },

  // IDE & Tools
  { name: 'VS Code', category: 'IDE & Tools', url: 'https://code.visualstudio.com/', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg', color: 'hover:bg-[#007ACC]/10 dark:hover:bg-[#007ACC]/10 hover:border-[#007ACC] dark:hover:border-[#007ACC] group-hover:text-[#007ACC] dark:group-hover:text-[#007ACC]' },
  { name: 'Git', category: 'IDE & Tools', url: 'https://git-scm.com/', logo: 'https://cdn.simpleicons.org/git', color: 'hover:bg-[#F05032]/10 dark:hover:bg-[#F05032]/10 hover:border-[#F05032] dark:hover:border-[#F05032] group-hover:text-[#F05032] dark:group-hover:text-[#F05032]' },
  { name: 'GitHub', category: 'IDE & Tools', url: 'https://github.com/', logo: 'https://cdn.simpleicons.org/github', color: 'hover:bg-[#181717]/10 dark:hover:bg-[#181717]/10 hover:border-[#181717] dark:hover:border-[#181717] group-hover:text-[#181717] dark:group-hover:text-[#181717]' },
  { name: 'IntelliJ IDEA', category: 'IDE & Tools', url: 'https://www.jetbrains.com/idea/', logo: 'https://cdn.simpleicons.org/intellijidea', color: 'hover:bg-[#000000]/10 dark:hover:bg-[#000000]/10 hover:border-[#000000] dark:hover:border-[#000000] group-hover:text-[#000000] dark:group-hover:text-[#000000]' },
  { name: 'Android Studio', category: 'IDE & Tools', url: 'https://developer.android.com/studio', logo: 'https://cdn.simpleicons.org/androidstudio', color: 'hover:bg-[#3DDC84]/10 dark:hover:bg-[#3DDC84]/10 hover:border-[#3DDC84] dark:hover:border-[#3DDC84] group-hover:text-[#3DDC84] dark:group-hover:text-[#3DDC84]' },
  { name: 'Roblox Studio', category: 'IDE & Tools', url: 'https://www.roblox.com/create', logo: 'https://cdn.simpleicons.org/roblox', color: 'hover:bg-[#000000]/10 dark:hover:bg-[#000000]/10 hover:border-[#000000] dark:hover:border-[#000000] group-hover:text-[#000000] dark:group-hover:text-[#000000]' },
];